import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isStreamingLive, isScheduledLive } from '@wix/wix-vod-shared/src/common/ui-selectors/video/live';
import { getAppLocale } from 'widget/selectors/app-settings';
import LiveLabel from '@wix/wix-vod-shared/src/widget/ui-components/live-label/live-label';

import i18n from '@wix/wix-vod-shared/src/common/i18n';
import sharedTranslations from 'messages/shared';
import ReminderIcon from './bell.svg';

@connect((state, { itemType, startTime }) => ({
  startTime,
  isStreaming: isStreamingLive({ itemType }),
  isScheduled: isScheduledLive({ itemType }) && Boolean(startTime),
  locale: getAppLocale(state),
}))
export default class LiveLabelContainer extends React.Component {
  static propTypes = {
    isStreaming: PropTypes.bool,
    isScheduled: PropTypes.bool,
    locale: PropTypes.string,
    startTime: PropTypes.number,
    videoTitle: PropTypes.string,
  };

  render() {
    return (<LiveLabel {...this.props}
                       liveText={i18n.t(sharedTranslations.live)}
                       scheduledSoonAriaLabel={i18n.t(sharedTranslations.scheduledSoonLabel)}
                       scheduledAriaLabel={i18n.t(sharedTranslations.scheduledLabel)}
                       startsInAriaLabel={i18n.t(sharedTranslations.startsIn)}
                       reminderAriaLabel={i18n.t(sharedTranslations.reminder)}
                       reminderIcon={<ReminderIcon />} />);
  }
}



// WEBPACK FOOTER //
// ./src/widget/containers/live-label/live-label.js